import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SYLLABUS_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import UpdateDeleteModal from "../../../globalComponents/Modals/UpdateDeleteModal/UpdateDeleteModal";
import { deleteSyllabusAction } from "../../../redux/actions/syllabusActions";
import DeleteItemModal from "../../../globalComponents/Modals/DeleteItemModal/DeleteItemModal";
import { FaFileDownload } from "react-icons/fa";
import { Button } from "@mui/material";
import { apiRoot } from "../../../apiRoot";
import { toast } from "react-toastify";

const toastError = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 2000,
    toastClassName: "custom-toast",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

const SyllabusCard = ({ data, mode, cellNumber }) => {
  const dispatch = useDispatch();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDownload = async () => {
    const url = "http://localhost:4000" + data.pdfUrl;
    const fileName = data.course.name + "-syllabus";
    try {
      const res = await fetch(url, { mode: "cors" });
      if (!res.ok) throw new Error("Network response was not ok");
      const blob = await res.blob();

      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      const safeName = String(fileName).replace(/[^\w\-]+/g, "_");

      a.download = `${safeName}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(a.href);
    } catch (e) {
      window.open(url, "_blank", "noopener,noreferrer");
    } finally {
    }
  };

  const updateItem = (modalType) => {
    dispatch({
      type: SYLLABUS_MODAL_ACTION_TYPE.GET_SYLLABUS_MODAL,
      payload: {
        data: data,
        openModal: modalType !== "more" ? true : false,
      },
    });
  };
  const deleteItem = () => {
    dispatch(deleteSyllabusAction(data._id));
  };

  const openConfirmModal = () => {
    dispatch({
      type: SYLLABUS_MODAL_ACTION_TYPE.OPEN_SYLLABUS_CONFIRM_MODAL,
      payload: {
        data: data,
        openModal: false,
        confirmModal: true,
      },
    });
  };

  const doubleClick = () => {
    updateItem("");
  };
  return (
    <>
      {showDeleteModal && (
        <DeleteItemModal
          setShowDeleteModal={setShowDeleteModal}
          deleteItem={deleteItem}
        />
      )}
      {mode === "desktop" ? (
        <tr onDoubleClick={doubleClick}>
          <td>
            <div className="td-con">
              <div className="table-scroll-text">
                {" "}
                {cellNumber}. {data.course.name}
              </div>
              <div className="right-fade"></div>
            </div>
          </td>
          <td>
            <div className="td-con">
              <div className="table-scroll-text">
                <Button
                  variant="contained"
                  sx={{ fontSize: "12px" }}
                  onClick={handleDownload}
                >
                  Endir
                  <FaFileDownload
                    style={{ marginLeft: "8px", fontSize: "16px" }}
                  />
                </Button>
              </div>
            </div>
          </td>

          <td>
            <UpdateDeleteModal
              updateItem={updateItem}
              deleteItem={deleteItem}
              data={data}
              openConfirmModal={openConfirmModal}
              profil={"syllabus"}
              setShowDeleteModal={setShowDeleteModal}
            />
          </td>
        </tr>
      ) : (
        <div className="content-box">
          <div className="left">
            <h3>{data.fullName}</h3>
            <ul>
              <li>
                <span>No:</span>
                <p>{data.orderNumber ? data.orderNumber : "boş"}</p>
              </li>
              <li>
                <span>Mövzu:</span>
                <p>{data.name ? data.name : "boş"}</p>
              </li>
            </ul>
          </div>
          <div className="right">
            <UpdateDeleteModal
              updateItem={updateItem}
              deleteItem={deleteItem}
              data={data}
              openConfirmModal={openConfirmModal}
              setShowDeleteModal={setShowDeleteModal}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default SyllabusCard;
